var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 13,
    cy: 6.5,
    rx: 1,
    ry: 1.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90187 9.5H5.28563C4.76951 9.5 4.33818 9.89279 4.29 10.4067L4.1025 12.4067C4.04751 12.9932 4.50898 13.5 5.09813 13.5H5.71437C6.23049 13.5 6.66182 13.1072 6.71 12.5933L6.8975 10.5933C6.95249 10.0068 6.49102 9.5 5.90187 9.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.71565C6 5.2877 6.27232 4.90718 6.67739 4.76912L8.82317 4.03776C9.18421 3.9147 9.53598 3.76599 9.8758 3.59275L11.5458 2.74136C12.2111 2.40217 13 2.88546 13 3.63226V3.85294V6.5V9.14706V9.36774C13 10.1145 12.2111 10.5978 11.5458 10.2586L10.9136 9.93633C9.89338 9.41622 8.77338 9.12119 7.62931 9.0712L6.95634 9.04179C6.42155 9.01842 6 8.57805 6 8.04274V5.71565Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2 6.28571C2 5.57563 2.57563 5 3.28571 5L4 5C4.55229 5 5 5.44772 5 6V7V8C5 8.55228 4.55228 9 4 9H3.28571C2.57563 9 2 8.42437 2 7.71429V6.28571Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.49507eb2a9a11ba2c27f38de94b49791.svg";
export { ForwardRef as ReactComponent };